/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_GInputs */

const en_mk_tut_mem_g = /** @type {(inputs: Mk_Tut_Mem_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is what makes agents more useful week by week. Every house rule you store is read by an agent before it works.`)
};

const id_mk_tut_mem_g = /** @type {(inputs: Mk_Tut_Mem_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini yang membuat agen makin berguna dari minggu ke minggu. Setiap aturan rumah yang Anda simpan akan dibaca agen sebelum ia bekerja.`)
};

/**
* | output |
* | --- |
* | "This is what makes agents more useful week by week. Every house rule you store is read by an agent before it works." |
*
* @param {Mk_Tut_Mem_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_g = /** @type {((inputs?: Mk_Tut_Mem_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_g(inputs)
	return en_mk_tut_mem_g(inputs)
});